<template>
  <div class="about fxd .f b-c b-cl a-c">
    <div class="a-c">
      <SwingTitle>@mohamadlounnas 😅</SwingTitle>
      <p class="o-5">I am the developer!</p>
      <router-link to="/" class="unt btn-n"><i class="material-icons -i-x">arrow_back</i>Go Home</router-link>
    </div>
  </div>
</template>
<script>
import SwingTitle from '../components/SwingTitle'

export default {
  components: {
    SwingTitle
  }
}
</script>
